module.exports = __webpack_public_path__ + "img/img13.175dead6.png";